const STICKY_MENU_ID = "#stickyMenu";

export function getStickyMenu() {
    return document.querySelector(STICKY_MENU_ID);
}

export function showMenu() {
    const stickyMenu = getStickyMenu();
    const menuStyle = stickyMenu.style;
    const menuClasses = stickyMenu.classList;
    menuStyle.top = 0;
    menuClasses.add("stuckToScreen");

    if (!menuClasses.contains("fadeIn")) {
        menuClasses.add("fadeIn");
    }
}


// WEBPACK FOOTER //
// ./utils/menuUtils.js